// The rule for reading a Hub table as cards on a phone (audit 2026-10-27,
// S1-M14 / S2-M11 / S3-M15: tables scrolled sideways inside their card and
// hid the numbers that matter). One implementation, used by the per-table
// `useCardLabels` hook and by the app-wide `HubTableCards` observer.
//
// DECISION: the observer adopts every `.mkt-tbl` instead of each page asking.
// Fourteen pages had a table that nobody had opted in; asking each page keeps
// the next table wide by default. A table that must stay a grid says so with
// `mkt-tbl--grid`, and the few with their own phone layout are listed below.

import { wantsCards } from "./card-table-rules";

/** Copy each column heading onto its cells as `data-label` (idempotent). */
export function labelCardTable(table: HTMLTableElement): void {
  const heads = Array.from(table.querySelectorAll("thead th")).map((th) => (th.textContent ?? "").trim());
  for (const row of Array.from(table.querySelectorAll("tbody tr"))) {
    let col = 0;
    for (const cell of Array.from(row.children) as HTMLTableCellElement[]) {
      const label = heads[col] ?? "";
      if (label) {
        if (cell.getAttribute("data-label") !== label) cell.setAttribute("data-label", label);
      } else if (cell.hasAttribute("data-label")) cell.removeAttribute("data-label");
      col += cell.colSpan || 1;
    }
  }
}

/** Mark and label every Hub table under `root` that wants cards. */
export function adoptCardTables(root: ParentNode): void {
  for (const table of Array.from(root.querySelectorAll<HTMLTableElement>("table.mkt-tbl"))) {
    if (!wantsCards(table)) continue;
    if (!table.classList.contains("mkt-tbl--cards")) table.classList.add("mkt-tbl--cards");
    labelCardTable(table);
  }
}
